import { render, staticRenderFns } from "./SlashMenuList.vue?vue&type=template&id=bda79b08"
import script from "./SlashMenuList.vue?vue&type=script&lang=js"
export * from "./SlashMenuList.vue?vue&type=script&lang=js"
import style0 from "./SlashMenuList.vue?vue&type=style&index=0&id=bda79b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports